import { Country } from "../models/Country";

export const getPhoneMask = ( country: Country ): string | Array<string> => {
  if( typeof country.mask === "string") {
    if( country.mask.charAt( 0 ) !== "+") country.mask = `${ country.mask }`;
  } else {
    country.mask = country.mask.map(( mask ) => {
      if( mask.charAt( 0 ) !== "+") return `${ mask }`;

      return mask;
    });
  }

  return country.mask;
};
